export const GALLERY_CATEGORY_IDS = [
  "festival-celebrations",
  "gaushala",
  "derasar",
  "outdoor-activities",
] as const;

export type GalleryCategoryId = (typeof GALLERY_CATEGORY_IDS)[number];

export type GalleryImage = {
  src: string;
  alt: string;
};

const festivalModules = import.meta.glob<{ default: string }>(
  "../assets/Festival-Celebrations/*.jfif",
  { eager: true }
);
const gaushalaModules = import.meta.glob<{ default: string }>(
  "../assets/Gaushala/*.jfif",
  { eager: true }
);
const derasarModules = import.meta.glob<{ default: string }>(
  "../assets/Deraser/*.jfif",
  { eager: true }
);
const outdoorModules = import.meta.glob<{ default: string }>(
  "../assets/Outdoor Activities/*.jfif",
  { eager: true }
);

function modulesToImages(
  modules: Record<string, { default: string }>,
  altPrefix: string
): GalleryImage[] {
  return Object.entries(modules)
    .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }))
    .map(([, mod], index) => ({
      src: mod.default,
      alt: `${altPrefix} ${index + 1}`,
    }));
}

export const GALLERY_BY_CATEGORY: Record<GalleryCategoryId, GalleryImage[]> = {
  "festival-celebrations": modulesToImages(
    festivalModules,
    "Festival and celebrations at Jivandhara"
  ),
  gaushala: modulesToImages(gaushalaModules, "Gaushala at Jivandhara"),
  derasar: modulesToImages(derasarModules, "Derasar at Jivandhara"),
  "outdoor-activities": modulesToImages(
    outdoorModules,
    "Outdoor activities at Jivandhara"
  ),
};

export const HOME_GLIMPSE_CATEGORIES: GalleryCategoryId[] = [
  "festival-celebrations",
  "gaushala",
  "derasar",
];

export const GALLERY_IMAGES = GALLERY_CATEGORY_IDS.flatMap(category =>
  GALLERY_BY_CATEGORY[category].map(image => image.src)
);
